<template>
  <div id="taskcenter" class="relativeItem">
    <!--4个背景色div-->
    <div class="redbk bkdiv" :class="{bkdivShow:bk_class_name == 'redbk'}"></div>
    <div class="bluebk bkdiv" :class="{bkdivShow:bk_class_name == 'bluebk'}"></div>
    <div class="purplebk bkdiv" :class="{bkdivShow:bk_class_name == 'purplebk'}"></div>
    <div class="lightPurplebk bkdiv" :class="{bkdivShow:bk_class_name == 'lightPurplebk'}"></div>

    <!--签到按���-->
    <img src="../../assets/task/task(11).png" class="signimg" @click="to_sign" />

    <!--导航-->
    <div class="nav-shell">
      <ul class="nav flex-box relativeItem center_nav" :style="{width:nav_width}">
        <li
          v-for="(n, index) in all"
          :key="index"
          class="relativeItem"
          :class="{ac:nav_index === index}"
          @click="change_nav(index)"
        >{{ n.catetitle }}</li>

        <!--滑块颜色-->
        <div class="absoluteItem centerY huakuai" :style="{left:nav_huakuai_left}">任务中心</div>
      </ul>
    </div>

    <!--任务模块-->
    <div v-if="all.length > 0">
      <swiper :options="swiperOption" ref="taskSwiper" class="center-swiper">
        <!-- slides -->
        <swiper-slide v-for="(n,index) in all" :key="index" class="center-slide">
          <!--底薪任务-->
          <dixin
            @change_bk="change_color"
            :obj="all[index].taskdown"
            v-if="all[index].keywords == 'basepay'"
          ></dixin>
          <!--日常任务-->
          <taskline
            :list="all[index].taskdown"
            :type="all[index].keywords"
            v-if="all[index].keywords == 'public'"
          ></taskline>
          <!--成就任务-->
          <tasklist
            :list="all[index].taskdown"
            @get_big_img="get_big_img"
            v-if="all[index].keywords == 'achievement'"
          ></tasklist>
        </swiper-slide>
      </swiper>
    </div>

    <!--大图弹出-->
    <tasklistTc :obj="big_img_obj" v-show="show_big_img"
      :clicknum="clicknum" @close_big_img="close_big_img"></tasklistTc>
  </div>
</template>










<script>
import dixin from "./dixin";
import tasklist from "./tasklist";
import taskline from "./taskline";
import tasklistTc from "./tasklistTc";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "taskcenter",
  components: { dixin, tasklist, tasklistTc, taskline, swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        speed: 500,
        autoplay: false,
        loop: false,
        self: this,
        centeredSlides: true,
        autoHeight: true, //高度随内容变化
        on: {
          slideChange: () => {
            this.nav_index = this.swiper.activeIndex;
            this.reset_bleft(this.nav_index);
          }
        }
      },
      dixin: [],
      xinshou: [],
      richang: [],
      chengjiu: [],
      all: [],
      nav_huakuai_left: "3px", //导航滑块的初始位置
      nav_index: 0, //顶部导航指示标
      nav_width: "100", //顶部导航的宽度根据标题数来设定
      bk_class_name: "lightPurplebk", //控制主背景的颜色的class名
      big_img_obj: {
        bigPicSrc: "",
        medalname: "",
        title: ""
      }, //大图展示用的对象数据
      show_big_img: false, //是否显示大图
      clicknum: '',
    };
  },
  methods: {
    /**子组件提示切换背景颜色 */
    change_color(index) {
      if (index === 0) {
        this.bk_class_name = "lightPurplebk";
      } else if (index === 1) {
        this.bk_class_name = "purplebk";
      } else if (index === 2) {
        this.bk_class_name = "redbk";
      } else if (index === 3) {
        this.bk_class_name = "bluebk";
      }
    },

    /**改变导航 */
    change_nav(index) {
      this.nav_index = index;
      this.swiper.slideTo(index);
      this.reset_bleft(index);
    },

    //点击时间切换设置标试点的位置
    reset_bleft(index) {
      let li = document
        .getElementsByClassName("center_nav")[0]
        .getElementsByTagName("li")[index];
      this.nav_huakuai_left = li.offsetLeft + "px";
    },

    /**从子组件接受大图数据 */
    get_big_img(data) {
      this.big_img_obj = data;
      this.show_big_img = true;
      this.clicknum = data.finished
    },

    /**关闭大图弹窗 */
    close_big_img() {
      this.show_big_img = false;
    },

    /**通知app打开签到界面 */
    to_sign() {
      this.$appAc.toSign();
    },

    /**获取总任务 */
    get_task_center() {
      let _this = this;
      this.$jsonp(this.$apis("taskcenter"), {}, res => {
        _this.all = res.data.data.data.list;
        //根据内容数组长度来设定顶部导航的宽度
        if (_this.all.length == 2) {
          _this.nav_width = "50%";
        } else if (_this.all.length == 3) {
          _this.nav_width = "75%";
        }
      });
    }
  },
  computed: {
    swiper() {
      return this.$refs.taskSwiper.swiper;
    }
  },
  mounted: function() {
    this.$tool.setTitle("任务中心");
    this.get_task_center();
    // this.swiper.autoplay.stop();
  },
  watch: {
    nav_index(val) {
      switch (val) {
        case 0:
          this.bk_class_name = "lightPurplebk";
          break;
        case 1:
          this.bk_class_name = "redbk";
          break;
        case 2:
          this.bk_class_name = "purplebk";
          break;
        case 3:
          this.bk_class_name = "bluebk";
          break;
        default:
          this.bk_class_name = "lightPurplebk";
      }
    }
  }
};
</script>








<style scoped>
#taskcenter {
  min-height: 100vh;
  padding: 15px 0;
  width: 100vw;
  overflow-x: hidden;
}
.bkdiv {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transition: all 0.6s;
  opacity: 0;
}
.bkdivShow {
  opacity: 1;
}
.signimg {
  width: 44px;
  position: fixed;
  right: 16px;
  bottom: 10%;
  z-index: 10;
}
.redbk {
  background: url("../../assets/task/task.png") no-repeat left top,
    linear-gradient(-190deg, #e96650, #971050);
  background-size: 100%;
}
.bluebk {
  background: url("../../assets/task/task.png") no-repeat left top,
    linear-gradient(-190deg, #3578e2, #3b20b1);
  background-size: 100%;
}

.lightPurplebk {
  background: url("../../assets/task/task.png") no-repeat left top,
    linear-gradient(-190deg, #ae24f6, #6206ae);
  background-size: 100%;
}
.purplebk {
  background: url("../../assets/task/task.png") no-repeat left top,
    linear-gradient(-190deg, #760bba, #420691);
  background-size: 100%;
}

/**顶部导航 */
.nav-shell {
  padding: 0 16px;
}
.nav {
  height: 30px;
  border-radius: 50px;
  padding: 3px;
  background: rgba(255, 255, 255, 0.16);
  color: white;
  font-size: 12px;
  justify-content: space-between;
  margin: 0 auto;
  margin-bottom: 15px;
}

.nav li,
.nav .huakuai {
  padding: 4px 10px;
  text-align: center;
  border-radius: 3rem;
  transition: all 0.6s;
}
.nav li {
  position: relative;
  z-index: 1;
}
.nav .huakuai {
  display: block;
  background: #ffd856;
  color: #ffd856;
  z-index: 0;
}
.nav .ac {
  color: #bb3215;
  /* background: #ffd856; */
}
.nav span {
  width: 6px;
  height: 6px;
  top: 4px;
  right: 8px;
  border-radius: 50%;
  background: #ff3f34;
}
</style>

<style>
.swiper-container {
  overflow: visible;
  overflow-y: visible;
}
.center-slide{
  height: 85vh !important;
  overflow-y: scroll;
}
.swiper-slide {
  padding: 0 16px;
}
</style>